import cn from "classnames";
import React from "react";
import { Button } from "ui";
import s from "./Resend.module.scss";
import { RestartBold } from "ui-v2/icons";

const INTERVAL = 60;
export function Resend({
  onResend,
  variant = "default",
  isResending = false,
}: {
  onResend: () => void;
  variant?: "default" | "darkText";
  isResending?: boolean;
}) {
  const [resendCount, setResendCount] = React.useState(0);
  const countRef: any = React.useRef(INTERVAL);
  const countElemRef: any = React.useRef();
  const btnRef: any = React.useRef();

  const intervalRef: any = React.useRef();

  function setText() {
    let durationTxt = "";
    const mins = Math.floor(countRef.current / INTERVAL);
    const secs = Math.ceil(countRef.current % INTERVAL);
    if (mins > 0) {
      durationTxt += mins;
      if (secs > 0) {
        durationTxt += ":";
        durationTxt += secs;
        durationTxt += "s";
      } else {
        durationTxt += " mins";
      }
    } else {
      durationTxt += secs;
      durationTxt += " s";
    }
    if (countElemRef.current)
      countElemRef.current.innerText = `Resend code in ${durationTxt}`;
  }

  React.useEffect(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (countRef.current !== undefined)
      countRef.current = INTERVAL * (resendCount + 1);

    if (countElemRef.current) countElemRef.current.style.display = "block";
    if (btnRef.current) btnRef.current.style.display = "none";

    intervalRef.current = setInterval(() => {
      if (countRef.current > 0) {
        if (btnRef.current) btnRef.current.style.display = "none";
        if (countElemRef.current) countElemRef.current.style.display = "block";
        setText();
        if (countRef.current) countRef.current -= 1;
      } else {
        if (countElemRef.current) countElemRef.current.style.display = "none";
        if (btnRef.current) btnRef.current.style.display = "block";
        if (countRef.current) countRef.current = INTERVAL * (resendCount + 1);
        if (countElemRef.current) countElemRef.current.innerText = `-`;
        if (intervalRef.current) clearInterval(intervalRef.current);
      }
    }, 1000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [resendCount]);

  function handleClick() {
    if (resendCount < 3) {
      setResendCount(resendCount + 1);
      onResend();
    }
  }

  if (resendCount >= 3) return null;

  return (
    <div
      className={cn(s.root, {
        [s.darkText]: variant === "darkText",
      })}
    >
      <div ref={countElemRef} className={s.counter}>
        -
      </div>
      <div ref={btnRef} className={s.btn}>
        {variant === "darkText" && (
          <Button
            label="Resend code"
            variant="ButtonGhostLink"
            onClick={() => handleClick()}
            leftIcon={<RestartBold />}
            isLoading={isResending}
            isDisabled={isResending}
          />
        )}
        {variant === "default" && (
          <Button
            label="Resend OTP"
            variant="ButtonGhostLink"
            onClick={() => handleClick()}
            isLoading={isResending}
            isDisabled={isResending}
          />
        )}
      </div>
    </div>
  );
}
